import { createStore } from 'redux';
import rootReducer from '../reducers/index';


// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const configureStore = () => {
  return {
    ...createStore(rootReducer, 
      // composeEnhancers(applyMiddleware(logger))
      // applyMiddleware(logger)
      )
  }
};

export default configureStore;